import '../styles/App.css'; // reuse homepage styles

export default function ToThink() {
  return (
    <div className="App">
      <div className="container">
        <div className="options">
          <a href="/">home</a>
        </div>

        <main className="essay">
          <h1>I think, we have forgotten how to think.</h1>

          <p className="essay-meta">
            2025
          </p>

          <hr />

          <p>
            I think that we have forgotten how to think. 
          </p>

          <p>A few years ago, words flowed out of me effortlessly. 
            Writing a 2,000-page paper felt like a ten-minute task. 
            New ideas emerged after a few minutes of bouncing thoughts around. 
            I spent most of my time chasing knowledge, learning, building, 
            stacking ideas on top of one another.</p>  

          <p>Now, something feels off.</p>  

          <p>I sit in complete silence, no distractions, staring at a screen as I type this - and my mind is blank. No noise. No ideas. Nothing. Just emptiness. Different. Weird.</p>  
          
          <p>How did this happen? <br />
            More importantly, <em>when</em> did it happen?</p>  

          <p>I went from chasing goals and learning relentlessly to spending hours doomscrolling, entire days consuming content.</p>  
          
          <p>Growing up, I was told that to speak a few lines on a stage, you must first consume many more - stories from people of different walks of life, books across disciplines, ideas from unfamiliar subjects. To be a sponge. The more you absorbed, the more you had within you.</p>  
          
          <p>So how does someone go from that state to feeling completely drained?</p>  
          
          <p>The answer, in my humble opinion, is simple - <b>brain rot is real.</b></p>  
          
          <p>It’s not just a term for stupid reels or endless TikToks. Something shifts as you keep scrolling, as you keep streaming. You move from thinking to agreeing. From questioning to accepting. From wrestling with ideas to instantly receiving answers - from an LLM, a feed, an algorithm.</p>  
          
          <p>I have read about instant gratification in the past. The concept is obvious, yet unavoidable. In a world where short-form content chips away at our attention spans and answers arrive instantly, we slowly lose the habit of thinking altogether. We trade effort for ease - and don’t notice what it costs us.</p>  
          
          <p>An article I read drew an interesting parallel. As humans evolved from cavemen and warriors to the “mighty modern man with his tech,” we lost the daily movement and physical strength that once defined us. Gyms emerged to compensate. To reclaim what was lost.</p>  
          
          <p>I can’t help but think the same will happen with our minds.</p>  
          
          <p>With our growing dependence on social media and LLMs, it isn’t far-fetched to imagine a future filled with “brain gyms” - places people visit two or three times a week just to ensure they can still think, to train their ability to reason.</p>  
          
          <p>When I first read that idea, I laughed and brushed it off.</p>  

          <p>Now, sitting alone at 11:35 p.m., staring at my laptop in absolute silence, it doesn’t seem funny anymore. It feels unsettling. As if the ability to think deeply has quietly become scarce.</p>
          
          <p>I also read <a href="https://farza.com/build-edu-machines" target="_blank" rel="noreferrer">this</a> essay by Farza about the need to build “education machines.” He wrote:</p>
        

          <blockquote>
            “Every industry is being completely revolutionized in front of our eyes - from manufacturing to software engineering to how we make memes. Yet when it comes to education, we’re still making stuff that…
            …helps students pass exams?”
          </blockquote>

          <p>That question stuck with me.</p>
          
          <p>Is learning even happening anymore?</p>
          
          <p>I look around and see students on both sides of me using ChatGPT to finish assignments and coast through college. We watch people openly use LLMs to cheat their way through interviews. Stranger still, we celebrate tools that help bypass the very skills those interviews are meant to measure.</p>

          <p>I see the outline of a coming problem - a global one - where every man gets the job done using the tools at his disposal, yet no man possesses the skills to do it without them.</p>

          <p>So I’ll say it again as I sit in the loud, blank silence where thoughts once used to be.</p>

          <p>Somewhere along the way I think we forgot how to think.</p>
           
        </main>

        
      </div>
      <footer>
        <hr />
        Kshitij Agarwal | don't feel shy,{" "}
        <a target="_blank" rel="noreferrer" href="mailto:omniscienthorizon@gmail.com">
          say hi👋
        </a>{" "}
        ps: i respond to every email :)
      </footer>
    </div>
  );
}
